import React from 'react'
import { useSelector } from "react-redux";
const ActionPopup = (props) => {
    const {widget_type} = props;
    const assignPermission = useSelector((state) => state.store_permission_data.permissionArr);
    const loginUserType = localStorage.getItem('type');
    return (
        <>
            <div className="menu menu-sub menu-sub-dropdown w-250px w-md-250px p-3" data-sai-menu="true">
                <div className="menu-item">
                    <a className="btn menu-link px-3 text-gray-600 fw-semibold btn-active-light-primary text-hover-primary" onClick={props.viewDetailsOnClick}>
                        View Details
                    </a>
                </div>
                {
                    (assignPermission.allow_data_edit === 'Y' || loginUserType == "SA") &&
                    <div className="menu-item">
                        <a className="btn menu-link px-3 text-gray-600 fw-semibold btn-active-light-primary text-hover-primary" onClick={props.virtualAgentUpdateOnClick}>
                            Edit Agent
                        </a>
                    </div>
                }
                {
                    (assignPermission.allow_data_delete === 'Y' || loginUserType == "SA") &&
                    <div className="menu-item">
                        <a className="btn menu-link px-3 text-gray-600 fw-semibold btn-active-light-primary text-hover-primary" onClick={props.virtualAgentDeleteOnClick}>
                            Delete Agent
                        </a>
                    </div>
                }
                {
                    widget_type === 'default_widget' && 
                    <div className="menu-item">
                        <a className="btn menu-link px-3 text-gray-600 fw-semibold btn-active-light-primary text-hover-primary" onClick={props.virtualAgentScriptCopyOnClick}>
                            Copy Integration Script
                        </a>
                    </div>
                }
                {loginUserType == "SA" && <div className="menu-item">
                    <a className="btn menu-link px-3 text-gray-600 fw-semibold btn-active-light-primary text-hover-primary" onClick={props.downloadCsvOnCLick}>
                        Download CSV
                    </a>
                </div>}
                {
                loginUserType == "SA" ? <div className="menu-item">
                    <a className="btn menu-link px-3 text-gray-600 fw-semibold btn-active-light-primary text-hover-primary" onClick={props.viewLogOnClick}>
                        View Logs
                    </a>
                </div>
                :
                <div className="menu-item">
                    <a className="btn menu-link px-3 text-gray-600 fw-semibold btn-active-light-primary text-hover-primary" onClick={props.viewLogOnClick}>
                        View Logs
                    </a>
                </div>
                }
                
            </div>
        </>
    )
}
export default ActionPopup